import cn from 'classnames';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Icon } from '@/shared/ui';

import { DiagnocoinFunding } from '../../config';

import styles from './DiagnocoinNotice.module.scss';

type DiagnocoinNoticeProps = {
  funding: DiagnocoinFunding;
  className?: string;
};

export const DiagnocoinNotice: FC<DiagnocoinNoticeProps> = (props) => {
  const { funding, className } = props;

  if (funding.source !== 'diagnocoins') {
    return null;
  }

  return (
    <div className={cn(styles.notice, className)}>
      <span className={styles.glyph}>
        <Icon name="cat" size={14} />
      </span>

      <FormattedMessage
        id="diagnocoins.deductionNotice"
        defaultMessage="{coins, plural, one {# Diagnocoin} other {# Diagnocoins}} will be deducted from your balance"
        values={{ coins: funding.coins }}
      />
    </div>
  );
};
